const ScanDetail = () => import('@/views/scan-detail/scan-detail.vue')

export default [
  {
    path: '/ScanDetail',
    name: 'ScanDetail',
    component: ScanDetail,
    meta: {
      keepAlive: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/ScanDetail.js